import { Injectable } from '@angular/core';
import { QueryParamsHandling, Router } from '@angular/router';
import { Routes } from '../../models/routes.enum';
import { StateModifier } from 'src/app/models/state/state-modifier.model';
import { StateValidation } from 'src/app/models/state/state-validation.model';
import { CompteDetention } from 'src/app/api/model/compte-detention.model';
import { Telephones } from 'src/app/api/model/telephones.model';
import { ConfigurationService } from '../configuration/configuration.service';
import { ConfigMeta } from 'src/app/models/meta';
import { GestionProvenanceService } from './gestion-provenance.service';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  constructor(
    private readonly router: Router,
    private readonly configurationService: ConfigurationService,
    private readonly gestionProvenanceService: GestionProvenanceService
  ) {}

  naviguerVersAccueil() {
    this.router.navigate([Routes.RACINE], { queryParamsHandling: this.obtenirValeurQueryParamsHandling() }).then();
  }

  naviguerVersAccueilSurRefresh(queryParams?: string) {
    this.router.navigateByUrl(Routes.RACINE + queryParams).then();
  }

  naviguerVersCredit() {
    this.router.navigate([Routes.CREDIT], { queryParamsHandling: this.obtenirValeurQueryParamsHandling() }).then();
  }

  naviguerVersPageErreurCredit(status?: string, codeErreur?: string, messageErreur?: string) {
    this.router
      .navigate([this.obtenirRouteCredit() + Routes.ERREUR], {
        state: { status: status, codeErreur: codeErreur, messageErreur: messageErreur },
        queryParamsHandling: this.obtenirValeurQueryParamsHandling(),
      })
      .then();
  }

  naviguerVersPageConfirmationCredit() {
    this.router
      .navigate([this.obtenirRouteCredit() + Routes.CONFIRMATION], {
        queryParamsHandling: this.obtenirValeurQueryParamsHandling(),
      })
      .then();
  }

  naviguerVersModificationCourrielCredit(compteDetention?: CompteDetention) {
    this.router
      .navigate([this.obtenirRouteCredit() + Routes.MODIFIER], {
        state: StateModifier.courriel(compteDetention),
        queryParamsHandling: this.obtenirValeurQueryParamsHandling(),
      })
      .then();
  }

  naviguerVersValiderCourrielCredit(compteDetention?: CompteDetention, comptesDetentionInitial?: CompteDetention[]) {
    this.router
      .navigate([this.obtenirRouteCredit() + Routes.VALIDATION], {
        state: StateValidation.courriel(compteDetention, comptesDetentionInitial),
        queryParamsHandling: this.obtenirValeurQueryParamsHandling(),
      })
      .then();
  }

  naviguerVersModificationTelephoneCredit() {
    this.router
      .navigate([this.obtenirRouteCredit() + Routes.MODIFIER], {
        state: StateModifier.telephone(),
        queryParamsHandling: this.obtenirValeurQueryParamsHandling(),
      })
      .then();
  }

  naviguerVersValiderTelephoneCredit(telephones?: Telephones[]) {
    this.router
      .navigate([this.obtenirRouteCredit() + Routes.VALIDATION], {
        state: StateValidation.telephone(telephones),
        queryParamsHandling: this.obtenirValeurQueryParamsHandling(),
      })
      .then();
  }

  naviguerVersCoordonnees() {
    this.router.navigate([Routes.COORDONNEES], { queryParamsHandling: this.obtenirValeurQueryParamsHandling() }).then();
  }

  naviguerVersModifierCoordonnees() {
    this.router
      .navigate([Routes.COORDONNEES + '/' + Routes.MODIFIER], {
        queryParamsHandling: this.obtenirValeurQueryParamsHandling(),
      })
      .then();
  }

  naviguerVersCoordonneesConfirmation() {
    this.router
      .navigate([Routes.COORDONNEES + '/' + Routes.CONFIRMATION], {
        queryParamsHandling: this.obtenirValeurQueryParamsHandling(),
      })
      .then();
  }

  naviguerVersModificationCredit() {
    this.router
      .navigate([this.obtenirRouteCredit() + Routes.MODIFIER], {
        state: StateModifier.coordonnees(),
        queryParamsHandling: this.obtenirValeurQueryParamsHandling(),
      })
      .then();
  }

  naviguerVersValiderCredit() {
    this.router
      .navigate([this.obtenirRouteCredit() + Routes.VALIDATION], {
        state: StateValidation.coordonnees(),
        queryParamsHandling: this.obtenirValeurQueryParamsHandling(),
      })
      .then();
  }

  naviguerVersValiderCoordonnees() {
    this.router
      .navigate([Routes.COORDONNEES + '/' + Routes.VALIDATION], {
        state: StateValidation.coordonnees(),
        queryParamsHandling: this.obtenirValeurQueryParamsHandling(),
      })
      .then();
  }

  naviguerVersPageErreurCoordonnees(status?: string, codeErreur?: string, messageErreur?: string) {
    this.router
      .navigate([Routes.COORDONNEES + '/' + Routes.ERREUR], {
        state: { status: status, codeErreur: codeErreur, messageErreur: messageErreur },
        queryParamsHandling: this.obtenirValeurQueryParamsHandling(),
      })
      .then();
  }

  naviguerVersUrlExterne(url: string): void {
    configuration.WindowService.nativeWindow.location.href = url;
  }

  obtenirRouteCredit(): string {
    return this.configurationService.isConfigEqualValue(ConfigMeta.OEL_CAAD_BANCAIRE_ACTIF, 'true')
      ? Routes.CREDIT + '/'
      : '';
  }

  obtenirValeurQueryParamsHandling(): QueryParamsHandling | null {
    return this.gestionProvenanceService.obtenirValeurQueryParamsHandling();
  }
}
